import { z } from 'zod';

import { defineService } from '@@api/lib/defineService';
import { Revision } from '@@api/services/revisions/schemas';
import config from '@@config';

export const revisionsService = defineService(
    (defineEndpoint) => ({
        revisionMetadata: {
            getDiffs: defineEndpoint({
                method: 'GET',
                path: '/revision/metadata/:id/diffs',
                pathParams: z.object({
                    id: z.number(),
                }),
                responses: {
                    200: z.array(Revision),
                },
            }),
        },
    }),
    {
        baseUrl: config.apiEnvVars.revisionsUrl,
    },
);
